import { useNavigate } from 'react-router-dom';
import { logout } from './api';

export function useLogout(): () => Promise<void> {
  const navigate = useNavigate();
  return async () => {
    await logout();
    navigate('/login', { replace: true });
  };
}
